











import { CrudOperation } from '@/types/CrudOperation';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class ApplicationHRForm extends Vue {
  @State('operation', { namespace: 'entity' })
  operation!: CrudOperation;

  get isReading() {
    return this.operation === CrudOperation.read;
  }

  get isCreation() {
    return this.operation === CrudOperation.create;
  }

  get isPreview() {
    return this.operation === CrudOperation.preview;
  }
}
